import Vue from 'vue'
import Router from 'vue-router'

import NProgress from 'nprogress'

import NotFound from './notFound'
import Login from './login'
import Register from './register'
import Activate from './activate'
import Home from './home'
import Plans from './plans'
import Databases from './databases'
import Users from './users'
import Options from './options'
import Invoices from './invoices'
import Payments from './payments'
import Requisites from './requisites'
import Instructions from './instructions'
import Support from './support'
import DesignSystem from './designSystem'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('../components/Page.vue'),
      meta: {
        root: true,
        layout: 'main',
        breadcrumb: {
          linkTo: 'home',
          linkText: 'Главная'
        }
      },
      children: [
        Home,
        Plans,
        Databases,
        Users,
        Options,
        Invoices,
        Payments,
        Requisites,
        Instructions,
        Support,
        DesignSystem
      ]
    },
    Login,
    Register,
    Activate,
    NotFound,
    {
      path: '*',
      redirect: {
        name: '404'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('user')
  const isPublic = to.matched.some(record => record.meta.public)

  if (!isPublic && !isAuthenticated) {
    // если не авторизованы, редиректим на страницу авторизации
    next({ name: 'login', query: { redirectTo: to.fullPath } })
  }

  if (isPublic && isAuthenticated) {
    // если авторизованы, редиректим со страниц авторизации на главную
    next({ name: 'home' })
  }
  next()
})

router.beforeResolve((to, from, next) => {
  // Если это не изначальная загрузка портала
  if (to.name) {
    NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {
  NProgress.done()
})

export default router